export interface MedalLevel {
  type: string;
  name: string;
  description: string;
  pointsRequired: number;
  discount: number;
}

export const MEDAL_LEVELS: MedalLevel[] = [
  {
    type: 'Iron',
    name: 'LOYALTY_PROGRAM_IRON_LEVEL',
    description: 'LOYALTY_PROGRAM_IRON_LEVEL_DESC',
    pointsRequired: 0,
    discount: 0
  },
  {
    type: 'Bronze',
    name: 'LOYALTY_PROGRAM_BRONZE_LEVEL',
    description: 'LOYALTY_PROGRAM_BRONZE_LEVEL_DESC',
    pointsRequired: 25000,
    discount: 20
  },
  {
    type: 'Silver',
    name: 'LOYALTY_PROGRAM_SILVER_LEVEL',
    description: 'LOYALTY_PROGRAM_SILVER_LEVEL_DESC',
    pointsRequired: 50000,
    discount: 30
  },
  {
    type: 'Gold',
    name: 'LOYALTY_PROGRAM_GOLD_LEVEL',
    description: 'LOYALTY_PROGRAM_GOLD_LEVEL_DESC',
    pointsRequired: 100000,
    discount: 40
  },
  {
    type: 'Platinum',
    name: 'LOYALTY_PROGRAM_PLATINUM_LEVEL',
    description: 'LOYALTY_PROGRAM_PLATINUM_LEVEL_DESC',
    pointsRequired: 200000,
    discount: 50
  }
];

export const MEDAL_TYPES = {
  IRON: 'Iron',
  BRONZE: 'Bronze',
  SILVER: 'Silver',
  GOLD: 'Gold',
  PLATINUM: 'Platinum'
} as const;

export type MedalType = typeof MEDAL_TYPES[keyof typeof MEDAL_TYPES];
